import Icon from "@material-ui/core/Icon"
import { FC } from "react"
import { ButtonProps } from "./Button"

const IconTopButton: FC<ButtonProps> = ({
  onClick,
  children,
  icon,
  doubleIconName,
  type,
  className,
  disabled
}) => {
  return (
    <button
      className={`ocs-btn icon-btn d-flex ${
        doubleIconName ? "double-icon" : ""
      } ${className ? className : ""}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      <span className="ocs-icon-wrapper">
        <Icon className="ocs-md-btn-icon">{icon} </Icon>
        {doubleIconName && <span>+</span>}
        {doubleIconName && (
          <Icon className="ocs-md-btn-icon">{doubleIconName} </Icon>
        )}
      </span>

      <span>{children}</span>
    </button>
  )
}

export default IconTopButton
